export const setStorage = (key, value) => {
  try {
    const valueToStore = typeof value === "object" ? JSON.stringify(value) : value;
    localStorage.setItem(key, valueToStore);
  } catch (error) {
    console.log("Error in set storage :: ", error);
  }
};

export const getStorage = (key, type) => {
  try {
    let value = localStorage.getItem(key);
    if (type === "object") value = JSON.parse(value);
    return value;
  } catch (error) {
    console.log("Error in get storage :: ", error);
  }
};

/**
 * Keys we DON'T wipe on logout / 401 / session reset.
 *
 * These are device-level preferences, not session state. Wiping them
 * on logout makes the cookie banner reappear on every login (CCPA/
 * GDPR consent is a device choice, not a session choice), and the
 * PWA install + feedback-bubble dismiss timers reset every time the
 * user logs out — which means the bubble pops up again 5 minutes
 * after they dismissed it for "30 days." Annoying.
 *
 * If you add a new device-level preference (analytics opt-in,
 * dark/light mode, language), add the key here.
 */
const PRESERVE_ON_LOGOUT = new Set([
  "stacked_cookie_consent",          // CCPA/GDPR consent record (per device, forever)
  "__pwa_dismissed_until__",         // PWA install prompt dismiss timer
  "__pwa_visit_count__",             // PWA prompt-after-N-visits counter
  "__feedback_bubble_dismissed_until__", // Feedback bubble dismiss timer
  "__paid_welcome_tour_seen__",      // Paid welcome tour shown once per device
  "__demo_membership__",             // Demo-gate signup → which tour to resume on next login (see demoMembership.js)
]);

export const clearStorage = () => {
  try {
    // Read the preserved values first, wipe everything, then restore.
    // Doing it this way is safer than enumerating keys to delete —
    // future code that adds login-state keys is automatically wiped,
    // and we never accidentally leak a session key by forgetting it.
    const preserved = {};
    for (const key of PRESERVE_ON_LOGOUT) {
      const val = localStorage.getItem(key);
      if (val !== null) preserved[key] = val;
    }
    localStorage.clear();
    for (const [key, val] of Object.entries(preserved)) {
      localStorage.setItem(key, val);
    }
  } catch {
    // If preserve fails for any reason, fall back to a full clear
    // rather than leaving a half-state.
    try { localStorage.clear(); } catch { /* nothing else we can do */ }
  }
  // sessionStorage is per-user-session by definition, so anything
  // there belongs to the user who's logging out. Examples that
  // matter: __demo_signup_email__ (would prefill the next user's
  // convert modal), __demo_ref__ (affiliate attribution), the 2FA
  // pending-userId. Wipe it all on logout — no preserve list
  // needed since sessionStorage already clears on tab close.
  try { sessionStorage.clear(); } catch { /* nothing else we can do */ }
}

export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.log("Error in remove storage :: ", error);
  }
}
